.content h2 {
	color: #35adb0;
	font-size: clamp(24px, 4vw, 32px);
	line-height: 1.25;
	margin: 32px 0 16px;
}

.content h3 {
	color: #263238;
	font-size: 22px;
	line-height: 1.4;
	margin: 24px 0 12px;
}

.content ol {
	color: #263238;
	line-height: 1.75;
	padding-left: 24px;
	margin-bottom: 22px;
}

.content li {
	margin-bottom: 8px;
}

.tableScroll {
	overflow-x: auto;
	margin-bottom: 24px;
}

.table {
	width: 100%;
	min-width: 540px;
	border-collapse: collapse;
	table-layout: fixed;
}

.table th,
.table td {
	border: 1px solid #ddd;
	padding: clamp(6px, 1.5vw, 14px);
	text-align: left;
	vertical-align: top;
}

.table thead {
	background: #f5f5f5;
}
